import { render, staticRenderFns } from "./OrdercaigouDetails.vue?vue&type=template&id=22e84efc&scoped=true"
import script from "./OrdercaigouDetails.vue?vue&type=script&lang=js"
export * from "./OrdercaigouDetails.vue?vue&type=script&lang=js"
import style0 from "./OrdercaigouDetails.vue?vue&type=style&index=0&id=22e84efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e84efc",
  null
  
)

export default component.exports